import VTableBody from './VTableBody'

export default {
  VTableBody
}
